// extracted by mini-css-extract-plugin
export default {"wrapper":"yy-z","response":"zy-z","error":"Ay-z","disabled":"By-z","buttons":"Cy-z","feedbackQuestionSection":"Dy-z","yesNoWrapper":"Ey-z"};